var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rowWrapper"},_vm._l((_vm.section.rows),function(row){return _c('row-item',{key:row.name,attrs:{"row":row,"label-position":_vm.section.labelPosition},on:{"removeRow":_vm.removeRow}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }